import EventType from 'ol/events/EventType.js';
import MapBrowserEvent from 'ol/MapBrowserEvent.js';
import {Options} from 'ol/interaction/Pointer.js';

import LineString from 'ol/geom/LineString';
import { Feature } from 'ol';
import { Pixel } from 'ol/pixel';
import { GeometryHelpers } from '@/geometryhelpers';
import { Coordinate } from 'ol/coordinate';
import { Renderer } from './Renderer';
import * as _ from 'lodash'
import ContextMenuEvent, { ContextMenuEventType } from './ContextMenuEvent';
import EventRememberingPointerInteraction from './EventRememberingPointerInteraction';

interface HoldDownInfo {
    func: _.DebouncedFunc<() => void>;
    pixel: Pixel;
}

export interface ShowMenuOptions {
    renderer: Renderer<any>;
}

export default class ShowMenu extends EventRememberingPointerInteraction {
    movingLine: Feature<LineString>|null = null
    startCoordinate: Coordinate|null = null
    holdDownInfo: HoldDownInfo|null = null
    holdDownEvent: Event|null = null
    renderer: Renderer<any>

    constructor(showMenuOptions: ShowMenuOptions, pointerOptions?: Options) {
        super(pointerOptions)
        this.renderer = showMenuOptions.renderer
    }

    handleEvent(event: MapBrowserEvent<any>) {

        if (event.originalEvent.type === EventType.CONTEXTMENU) {
            // Avoid context menu for long taps when drawing on mobile
            event.preventDefault();
        }

        if(event.type === 'pointerup' || event.type === 'pointerdown') {
            if(this.holdDownInfo !== null) {
                this.holdDownInfo.func.cancel()
                this.holdDownInfo = null
            }
        }

        if(this.holdDownInfo !== null && event.type === 'pointermove' && !GeometryHelpers.isVeryClose(this.holdDownInfo.pixel, event.pixel)) {
            this.holdDownInfo.func.cancel()
            this.holdDownInfo = null
        }

        if(event.type === 'pointerdown') {
            this.holdDownInfo = {
                func: _.debounce(() => this.heldDown(event), 1000),
                pixel: event.pixel
            }
            this.holdDownInfo.func()

            this.dispatchEvent(new ContextMenuEvent(ContextMenuEventType.RequestHide, event.pixel, event.coordinate))
            // this hides the existing context menu if we click on the map background outside the contextmenu
            // (pointerdown doesn't fire on this interaction if we click on the context menu itself)
        }

        return super.handleEvent(event)
    }

    heldDown(event: MapBrowserEvent<any>) {
        this.holdDownEvent = event.originalEvent
        this.dispatchEvent(new ContextMenuEvent(ContextMenuEventType.RequestShow, event.pixel, event.coordinate))
    }
}
